import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/** @jsx jsx */
import React from 'react';
import { PopupSelect } from '@atlaskit/select';
import Trigger from './Trigger';
import * as components from './components';
import { KEY_ARROW_DOWN, KEY_ARROW_UP, KEY_TAB } from '../constants';
import { createAndFireEvent, withAnalyticsContext, withAnalyticsEvents } from '@atlaskit/analytics-next';
import { getOptions } from '../utils';
import { css, jsx } from '@emotion/react';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { injectIntl } from 'react-intl-next';
import messages from '../messages';
const defaultPopperProps = {
  strategy: 'fixed',
  modifiers: [{
    name: 'offset',
    options: {
      offset: [0, 8]
    }
  }],
  placement: 'bottom-start'
};
const packageName = "@atlaskit/color-picker";
const packageVersion = "3.2.13";
class ColorPickerWithoutAnalyticsBase extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "createAndFireEventOnAtlaskit", createAndFireEvent('atlaskit'));
    _defineProperty(this, "state", {
      isTabbing: false
    });
    _defineProperty(this, "changeAnalyticsCaller", () => {
      const {
        createAnalyticsEvent
      } = this.props;
      if (createAnalyticsEvent) {
        return this.createAndFireEventOnAtlaskit({
          action: 'clicked',
          actionSubject: 'color-picker',
          attributes: {
            componentName: 'color-picker',
            packageName,
            packageVersion
          }
        })(createAnalyticsEvent);
      }
      return undefined;
    });
    _defineProperty(this, "onChangeSelect", option => {
      this.props.onChange(option.value, this.changeAnalyticsCaller());
    });
    _defineProperty(this, "onOptionKeyDown", value => {
      this.props.onChange(value, this.changeAnalyticsCaller());
    });
    _defineProperty(this, "onKeyDown", e => {
      const key = e.key;
      if (key === KEY_TAB) {
        this.setState({
          isTabbing: true
        });
      } else if (key === KEY_ARROW_UP || key === KEY_ARROW_DOWN) {
        this.setState({
          isTabbing: false
        });
      } else if (getBooleanFF('platform.color-picker-radio-button-functionality_6hkcy') && key === 'Escape') {
        e.stopPropagation();
      }
    });
    _defineProperty(this, "getFullLabel", (intl, value, label) => {
      if (getBooleanFF('platform.jca11y-1480-inappropriate-label-for-color-picker_76tfe')) {
        if (value && value.label) {
          return intl.formatMessage(messages.colorPickerAriaLabel, {
            color: value.label,
            message: label
          });
        } else {
          return label;
        }
      } else {
        return intl.formatMessage(messages.colorPickerAriaLabelOldFormat, {
          color: value.label,
          message: label
        });
      }
    });
  }
  render() {
    const {
      palette,
      selectedColor,
      checkMarkColor,
      cols,
      popperProps = defaultPopperProps,
      label = 'Color picker',
      selectedColourSwatchSize,
      showDefaultSwatchColor = true,
      isDisabledSelectedSwatch,
      intl
    } = this.props;
    const {
      options,
      value
    } = getOptions(palette, selectedColor, showDefaultSwatchColor);
    const fullLabel = this.getFullLabel(intl, value, label);
    return jsx(PopupSelect, {
      target: ({
        ref,
        isOpen
      }) => jsx("div", {
        css: colorCardWrapperStyles,
        ref: ref
      }, jsx(Trigger, _extends({}, value, {
        label: fullLabel,
        expanded: isOpen
      }, getBooleanFF('platform.color-picker-radio-button-functionality_6hkcy') && {
        swatchSize: selectedColourSwatchSize,
        isDisabled: isDisabledSelectedSwatch
      }))),
      popperProps: popperProps,
      maxMenuWidth: "auto",
      minMenuWidth: "auto",
      options: options,
      "aria-label": fullLabel,
      value: value,
      components: components,
      onChange: this.onChangeSelect
      // never show search input
      ,
      searchThreshold: Number.MAX_VALUE
      // palette props
      ,
      cols: cols,
      checkMarkColor: checkMarkColor,
      onKeyDown: this.onKeyDown,
      isTabbing: this.state.isTabbing,
      onOptionKeyDown: this.onOptionKeyDown
    });
  }
}
export const ColorPickerWithoutAnalytics = injectIntl(ColorPickerWithoutAnalyticsBase);
export default withAnalyticsContext({
  componentName: 'color-picker',
  packageName,
  packageVersion
})(withAnalyticsEvents()(ColorPickerWithoutAnalytics));
const colorCardWrapperStyles = css({
  display: 'inline-block'
});